export const moneyFormatterEur = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
});

export const moneyFormatterMDL = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'MDL',
  minimumFractionDigits: 0,
});
